import { Toolbar } from "primereact/toolbar";
import { classNames } from "primereact/utils";

import styles from "./list-toolbar.module.scss";
import type { ListToolbarViewProps } from "./types-list-toolbar";

export function ListToolbarView({
  ariaLabel,
  className,
  style,
  framed,
  testId,
  start,
  end,
  rest,
}: ListToolbarViewProps) {
  return (
    <Toolbar
      aria-label={ariaLabel}
      className={classNames(styles.root, className)}
      style={style}
      data-framed={framed || undefined}
      data-testid={testId}
      start={start}
      end={end}
      pt={{ start: { className: styles.start }, end: { className: styles.end } }}
      {...rest}
    />
  );
}
